<template>
	<div class="form">
		<h4 class="step-title">
			<label for="VehicleMake">Vehicle Make</label>
		</h4>
		<ValidationObserver v-slot="{ errors, handleSubmit }" @submit.prevent>
			<div id="spinner-container" class="d-flex justify-content-center" v-if="loading && showSpinner">
				<div id="spinner" class="spinner-border text-light" role="status">
					<span class="sr-only">Loading...</span>
				</div>
			</div>
			<div
				class="step-content step-button-list d-flex flex-column align-items-center"
				v-if="!loading"
			>
				<scrollable-button-list
					v-bind:items="makes"
					v-bind:onclick="complete"
					v-if="makes.length > 0"
					v-bind:value="vehicle.make"
				/>
				<div class="step-item" v-if="makes.length == 0">
					<ValidationProvider
						mode="eager"
						vid="vehicleMake"
						name="Vehicle make"
						rules="required"
					>
						<input
							id="vehicleMakeText"
							class="form-control"
							type="text"
							v-on:keyup.enter="enterKeyup"
							v-model="vehicle.make"
						/>
					</ValidationProvider>
				</div>
				<div
					class="step-item"
					v-if="
						errors['vehicleMake'] &&
						errors['vehicleMake'].length > 0
					"
				>
					<div class="alert alert-danger">
						{{ errors["vehicleMake"][0] }}
					</div>
				</div>
				<div class="step-item" v-if="makes.length == 0">
					<button
						class="btn step-btn"
						ref="complete"
						v-on:click="handleSubmit(complete)"
					>
						Continue
					</button>
				</div>
			</div>
		</ValidationObserver>
	</div>
</template>

<script>
import ScrollableButtonList from "../shared/ScrollableButtonList.vue";
import { extend } from "vee-validate";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { required } from "vee-validate/dist/rules";

extend("required", {
	...required,
	message: "{_field_} is required.",
});

export default {
    name: "VehicleMake",
    components: {
        ScrollableButtonList,
        ValidationProvider,
        ValidationObserver
    },
    props: {
		appState: Object,
        lead: Object
    },
    data: function() {
        return {
            loading: true,
            showSpinner: false,
            createdTime: new Date().getTime(),
            minimumElapsedMillisecondsBeforeShowingSpinner: 100,
            loadMakesCheckIntervalInMilliseconds: 100,
            makes: []
        }
    },
    created: function() {
        this.loadMakes();
    },
    computed: {
        vehicle: function() {
            return this.lead.autoInsurance.vehicles[this.lead.autoInsurance.vehicles.length-1];
        }
    },
    methods: {
        loadMakes: function() {
            var time = new Date().getTime();

            this.utils.log("loadMakes");
            this.utils.log(this.loading + ", " + time + ", " + this.createdTime);

            var makeModelTrims = this.appState.makeModelTrimsByYear[this.vehicle.year];

            // load make model trims
            if (this.loading && makeModelTrims) {
                this.utils.log("adding makes");

                var makes = this.makes;

                Object.keys(makeModelTrims).forEach(function(key) {
                    makes.push({ text: key, value: key });
                });

                this.loading = false;
            }
            // fallback to manual entry
            else if (time - this.createdTime > this.appConfig.requestTimeoutInMilliseconds) {
                this.utils.log("fallback to manual entry");
                this.loading = false;
            }
            // try loading again
            else {
                if (!this.showSpinner && time - this.createdTime > this.minimumElapsedMillisecondsBeforeShowingSpinner) {
                    this.showSpinner = true;
                }

                this.utils.log("trying again");
                setTimeout(this.loadMakes, this.loadMakesCheckIntervalInMilliseconds);
            }
        },
        enterKeyup: function() {
            this.$refs.complete.click();
        },
        complete: function(value) {
            if (value) {
                this.vehicle.make = value;
            }

            this.$emit("complete", this.$options.name, value);
        }
    }
}
</script>
